import React from "react";
import PropTypes from "prop-types";

const Select = props => {
	return (
		<select
			className="bg-transparent text-defaultRegistrationInput font-defaultRegistrationInput outline-none mb-2 ml-3 mr-4"
			{...props.attributes(props.item)}
			onChange={e => {
				props.setValue(props.item.name, e.target.value);
			}}>
			{props.item.option.map((it) => {
				return (
					<option key={"option-" + it} value={it.value} {...props.attributes(it)}>
						{it.text}
					</option>
				);
			})}
		</select>
	);
};

Select.propTypes = {
	item: PropTypes.object,
	attributes: PropTypes.func,
	setValue: PropTypes.func
};

export default Select;
